import '../sass/app.scss';
import '../css/app.css';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';

import '../assets/fonts/geometria/stylesheet.css'
import '../assets/fonts/montserrat/stylesheet.css'
import '../assets/fonts/sfprodisplay/stylesheet.css'


import '../assets/css/main.css';
import '../assets/css/footer.css';
import '../assets/css/navbar.css';
import '../assets/css/ui.css';
import '../assets/css/users.css';
import '../assets/css/header.css';
import '../assets/css/home.css';
import '../assets/css/filter.css';
import '../assets/css/rooms-list.css';
import '../assets/css/modal.css';
import '../assets/css/experts.css';
import '../assets/css/backgrount.css';
import '../assets/css/news.css';
import '../assets/css/files-component.css';
import '../assets/css/messages.css';

// Импорт модального окна для изображений
import '../assets/js/image-modal.js';
// Импорт отладочного скрипта для отступов
// import '../assets/js/debug-spacing.js'; // Закомментировано - файл не существует

import './bootstrap';
// require('./bootstrap');

import { createApp } from 'vue'

import appRouter from "./router/index.js";
import store from "./store/index.js";

import VclickOutside from "./directives/VclickOutside.js";
import VIntersections from "./directives/VIntersections.js";

import App from './App.vue'
import login from "./Pages/Sso/login.vue";
import { postToParent } from "./iframeParent.js";

const app = createApp(App)

// Глобальная функция
app.config.globalProperties.updateWindowHeight = function(height = 0) {
  try {
      let windowHeight = window.screen.height;
    if(height){
        height = windowHeight > height ? windowHeight : height;
        postToParent({ height: height, type: 'resize' });
    }
  }catch (e) {
    console.log('error resize', e)
  }

};

app.directive('click-outside', VclickOutside)
app.directive('intersection', VIntersections)
app.use(appRouter)
app.use(store)

// Выводим информацию о Vite в консоль (только в dev режиме)
if (import.meta.env.DEV) {
  console.log('🚀 Vite Development Server Active');
  console.log('📦 Mode:', import.meta.env.MODE);
  console.log('🔧 Dev:', import.meta.env.DEV);
  console.log('🌐 Base URL:', import.meta.env.BASE_URL);
  console.log('⚡ HMR enabled with source maps');
  console.log('🔧 ENV:', import.meta.env);
}

app.mount('#app');
